// Supabase Auth context: sessionを一元管理し、各コンポーネントでの重複getUser/getSessionを回避
import React, { createContext, useContext, useEffect, useState } from "react";
import supabase from "./supabase";

const AuthContext = createContext({
  session: undefined, // undefined=loading, null=not signed in, object=signed in
  user: undefined,
});

export function SupabaseAuthProvider({ children }) {
  const [session, setSession] = useState(undefined); // undefined while checking

  useEffect(() => {
    let mounted = true;
    supabase.auth.getSession().then(({ data }) => {
      if (!mounted) return;
      setSession(data?.session || null);
    });
    const { data: sub } = supabase.auth.onAuthStateChange((_event, newSession) => {
      if (!mounted) return;
      setSession(newSession || null);
    });
    return () => {
      mounted = false;
      sub?.subscription?.unsubscribe();
    };
  }, []);

  const value = {
    session,
    user: session?.user || null,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useSupabaseSession() {
  return useContext(AuthContext);
}
